import $ from "jquery";
import api from "./api"
// import { MessageBox } from 'element-ui';
import { Loading } from 'element-ui';
import { Message } from 'element-ui';

export const hasClass = function (elem, cls) {
  cls = cls || '';
  if (cls.replace(/\s/g, '').length === 0 || !elem) return false;
  return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');
};

export const addClass = function (ele, cls) {
  if (!hasClass(ele, cls)) {
    ele.className = ele.className === '' ? cls : ele.className + ' ' + cls;
  }
};

export const removeClass = function (ele, cls) {
  if (hasClass(ele, cls)) {
    let newClass = ' ' + ele.className.replace(/[\t\r\n]/g, '') + ' ';
    while (newClass.indexOf(' ' + cls + ' ') >= 0) {
      newClass = newClass.replace(' ' + cls + ' ', ' ');
    }
    ele.className = newClass.replace(/^\s+|\s+$/g, '');
  }
};

export const toggleClass = function (ele, cls) {
  if (hasClass(ele, cls)) {
    removeClass(ele, cls)
  } else {
    addClass(ele, cls)
  }
};


/**
 * 验证手机号码格式
 */
export const isMobile = function (tel) {
  let reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
  return reg.test(tel)
}
const turnAround = (sec) => {
  if (sec > 5) {
      $('.wrap_loading .circle').addClass('clip-auto');
      $('.wrap_loading .right').removeClass('wth0');
  }
  $('.wrap_loading .left').css("-webkit-transform", "rotate(" + 36 * sec + "deg)");
  $('.wrap_loading .progress-num>span').text(sec);
}
window.reloadPage = () => {
  console.log('reload the page ')
  window.location.reload()
}

export const modelLoadingMask = () => {
  let reload1 = null;
  let reload = null;
  let mask = $('#mask')
  let loading1 = $('#loading1')
  if (JSON.stringify(mask) != '{}' || JSON.stringify(loading1) != '{}') {
    $('#mask').remove()
    $('#loading1').remove()
  }
  return {
    loading: (id) => {
			let num = 10;
      var str = `<div id="mask" class="global_loading_mask"></div>
                <div class="global_loading_mask_fixed-container" id="loading1">
                  <div class="loading1-text">
                    <span>用创新重构我们的三维世界</span>
                 </div>
                <div class="fixed-bg loading1-bg"></div>
                  <div class="loading1-icon">
                    <div class="loading1-icon-text">模型加载中…
                      <p style="margin-top:20px;">
                        <span id="reload1" style="color:#ffffff; font-size: 16px; border:1px solid #fff; border-radius: 50px; padding: 5px 50px; display:none;cursor: pointer;" onclick="reloadPage()">重新加载</span>
                      </p>
                    </div>
                    <div id="loading1-div" class="wrap_loading">
                        <div class="circle">
                            <div class="percent left"></div>
                            <div class="percent right wth0"></div>
                        </div>
                        <div class="progress-num"><span id="progress1">1</span></div>
                    </div>
                </div>`
				if(id == 'node'){
					$('#node-model').append(str)
				}else{
					$('body').append(str)
				}

        clearInterval(reload1)
        reload1 = setInterval(() => {
						
            let progress = parseInt($('#progress1').html());
						console.log('progress',$('#progress1').html())
            if (progress < num) {
                progress += 1;
                $('#progress1').html(progress)
                turnAround(progress)
                // if (has3DModel === true || noPhoto === true) {
                //     window.get_loading.remove_loading()
                // }
            } else {
								console.log(id)
								if(id == 'live-action' || id== 'node'){
									$('#loading1-div').remove()
									window.get_loading.remove_loading()
								}else{
									$('#reload1').show()
									$('#loading1-div').remove()
								}
								$('#progress1').text('1')
								clearInterval(reload1)
            }
        }, 1000)
    },
    remove_loading: function() {
      // return
      $('#mask').fadeOut(1500)
      $('#loading1').fadeOut(1500)
      clearInterval(reload1)
      setTimeout(function() {
        $('#mask').remove()
        $('#loading1').remove()
      }, 1600)

    }
  }
}

/**
 * 
 * @param {right / left} clickType 
 * @param {列表} arr 
 * @param {左右点击的dom} currentDom 
 * @param {要移动的list富元素} listDom 
 * @param {移动的距离} translateX 
 */
export const TransformFun = (clickType, arr, currentDom, listDom, translateX, margin) => {
  margin = margin || 0
  // debugger
  if (!arr.length) {return}
  let boxWidth
  let itemWidth
  if (clickType == 'right') {
    boxWidth = $(currentDom).prev().innerWidth();
    itemWidth = $(currentDom).prev().find('.list-item').innerWidth() + margin;
  } else {
    boxWidth = $(currentDom).next().innerWidth();
    itemWidth = $(currentDom).next().find('.list-item').innerWidth() + margin;
  }
  let totalX = arr.length * itemWidth - boxWidth 
  if (totalX < 0) {
    return
  }

  if (clickType == 'right') {
    if (Math.abs(translateX) + boxWidth < totalX) {
      translateX -= boxWidth
    } else {
      translateX = -totalX
    }        
  } else {
    if (Math.abs(translateX) - boxWidth > 0) {   
      translateX += boxWidth
    } else {
      translateX = 0
    }
  }
  console.log('this.translateX --- ', translateX)

  $(listDom).css('transform', `translateX(${translateX}px)`) 
  return translateX
}


//图片上传

export const UploadPicFile = (file) => {
  return new Promise((resolve, reject) => {
    if (file) {
      let loading = BaseLoading()
      let formData = new FormData();
      formData.append("file", file);
      api.uploadPic(formData).then(res => {
        setTimeout(() => {
          loading.close()
        }, 500);
        console.log('uploadPicFile file res ', res)
        if (res.data.code === 200) {
          BaseMessage.success('图片上传成功')
          resolve(res.data.result)
        } else {
          BaseMessage.error('图片上传失败')
          resolve(false)
        }
      })
    }
  })
}

/**
 * //图片上传
 * @param {*} file 要上传的文件
 * @param {*} i 当前的文件列表索引
 * @param {*} len 上传列表的数量
 */
export const UploadPicFileMultiple = (files, dataArr, maxLen) => {
  let picArr = []
  let n = 0
  
  return new Promise((resolve, reject) => {
    if (files) {
      files = Array.from(files)
      let len = files.length
      let data_len = dataArr.length
      let total_len = data_len + len
      if (total_len > maxLen) {
        BaseMessage.warning(`图片最多只能上传${maxLen}张`);
        len = maxLen - data_len
        files = files.splice(0, len)
      }
      
      for(let i = 0; i < len; i++) {
        if (i == 0) {
          var loading = BaseLoading()
        }
        let formData = new FormData();
        formData.append("file", files[i]);
        api.uploadPic(formData).then(res => {
          n ++ 
          if (res.data.code === 200) {
            // resolve(res.result)
            picArr.push(res.data.result.url)
          } else {
            BaseMessage.error('上传失败')
            resolve(false)
          }

          //当有多个文件时，等待所有文件上传后再关闭loading
          if (n === len) {
            loading && loading.close()
            resolve(picArr)
            BaseMessage.success('上传完成')
          }
        })
      }

    }
  })
}

export const GetUrlQuery = () => {
  return new Promise((resolve, reject) => {
    let paramsObj = {};
    let search = decodeURI(window.location.search.substr(1));
    if (search) {
      let arr = search.split("&");
      arr.forEach(item => {
        let temArr = item.split("=");
        paramsObj[temArr[0]] = temArr[1];
      });
    } else if (localStorage.getItem('openid')) {
      paramsObj = {
        openid: localStorage.getItem('openid'),
        web_token: localStorage.getItem('web_token')
      }
    } else {
      resolve()
      return
    }
    resolve(paramsObj);
  });
}

/*
export const CheckStatus = (param) => {
  console.log('CheckStatus -- param ', param)
  // if (!localStorage.getItem('user_info')) {
    UserApi.loginByToken(param).then(res => {
      if (res.code === 200) {
        localStorage.setItem('web_token', param.web_token)
        localStorage.setItem("openid", res.result.openid);
        localStorage.setItem(
          "user_info",
          JSON.stringify(res.result.user_info)
        );
        localStorage.setItem("user_id", res.result.user_info.id);
      }
    })    
  // }
}*/

export const BaseLoading = () => {
  let loading = Loading.service({
    lock: true,
    text: '加载中',
    // spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.5)'
  });
  return loading
} 

export const BaseMessage = {
  success: (msg) => {
    Message.success({
      showClose: true,
      message: msg
    })
  },
  warning: (msg) => {
    Message.warning({
      showClose: true,
      message: msg
    })
  },
  error: (msg) => {
    Message.error({
      showClose: true,
      message: msg
    })
  }
}

export const SendLog = (param, other_param) => {
	let end_time = new Date().getTime()
	let userAgent = window.navigator.userAgent
	let width = window.innerWidth
  let height = window.innerHeight
  
  let time_diff = ''

  if (end_time && other_param.start_time) {
    time_diff = ((end_time - other_param.start_time) / 1000)
  }

	const params = {
		from: 'web',
		userAgent: userAgent,
		width: width,
		height: height,
		request: other_param.url,
    param: param,

    step: other_param.step + `， 时间差：'${time_diff}' 秒`,
		
		cur_page: other_param.cur_page,
		
		pre_page: other_param.pre_page,

		start_time: other_param.start_time,
		end_time: end_time
  }
  console.log('----------------- to send log ', params)
  return
	api.sendSysLog(params).then(res => {
		console.log('this is send sys log res ', res)
	})
}

// 微信配置初始化
export const wxInit = () => {
  let param = {
    url: window.location.href
  }
  api.wechatConfig(param).then(res => {
    console.log('wechatConfig res ', res)
    if (res.data.code == 200) {
      let result = res.data.result
      wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: result.appId, // 必填，公众号的唯一标识
          timestamp: result.timestamp, // 必填，生成签名的时间戳
          nonceStr: result.nonceStr, // 必填，生成签名的随机串
          signature: result.signature,// 必填，签名
          // jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        console.log('微信配置初始化成功 --- ')
      });
      wx.error(function(res){
        console.log('微信配置初始化失败', res)
      });
    }
  })
}





// WEBPACK FOOTER //
// ./src/utils/Tbase.js